module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salesCommission"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.salesCommissionLan.saleAccount) + " : " + _vm._s(_vm.$route.query.id)), (_vm.showPreview) ? _c('span', [_vm._v(" - " + _vm._s(_vm.salesCommissionLan.btnGroup.commissionPreviewBtn))]) : _vm._e()]), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "pull-right viewBtn-box"
  }, [_c('button', {
    staticClass: "double",
    on: {
      "click": function($event) {
        _vm.viewBtn = 'double'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.salesCommissionLan.contrastBrowse) + "\n      ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.viewBtn = 'onlyOne'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.salesCommissionLan.singlepageBrowse) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.showPreview) ? _c('button', {
    staticClass: "pull-right preview-btn",
    on: {
      "click": function($event) {
        _vm.showPreview = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.salesCommissionLan.btnGroup.commissionPreviewBtn) + "\n    ")]) : _c('button', {
    staticClass: "pull-right preview-btn",
    on: {
      "click": function($event) {
        _vm.showPreview = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.salesCommissionLan.btnGroup.back) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.showPreview) ? _c('div', {
    staticClass: "content-box"
  }, [_c('sale-commission-preview', {
    attrs: {
      "region": _vm.curArea,
      "multiLanguage": _vm.salesCommissionLan,
      "reqData": _vm.reqData
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "content-box"
  }, [(_vm.viewBtn == 'double') ? _c('div', {
    staticClass: "version0",
    class: {
      'doubleView margin-right': _vm.viewBtn === 'double'
    }
  }, [_c('sale-commission-content', {
    ref: "version0",
    attrs: {
      "multiLanguage": _vm.salesCommissionLan,
      "version": '0',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "version1",
    class: {
      'doubleView': _vm.viewBtn === 'double'
    }
  }, [_c('sale-commission-content', {
    ref: "version1",
    attrs: {
      "multiLanguage": _vm.salesCommissionLan,
      "version": '1',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    },
    on: {
      "afterVerify": _vm.afterVerifyFn
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc68c8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/Sale/SaleSetting/saleCommissionSetting.vue
// module id = 1082
// module chunks = 1